import { useModal } from "../../../../../hooks";
import { OrdersShipmentDeliveryConfirmFileType } from "../../../../order/orders/detail/interface";
import { useDownloadShipmentFile } from "../../../../order/orders/list/hooks/useDownloadShipmentFile";
import { usePostOrderShipmentDownloadShipmentFile } from "../hooks/usePostOrderShipmentDownloadShipmentFile";
import { PcsDetailType } from "../interface";
import React from "react";

interface PropsType {
    pcsDetail: PcsDetailType
    menuTitleText: string
    isPcsDelivery?: boolean
}

export default function Tab1({ pcsDetail, menuTitleText, isPcsDelivery }: PropsType) {
    const { mutate: mutateDownloadShipmentFile } = usePostOrderShipmentDownloadShipmentFile();
    const { handleModal } = useModal();
    const downloadShipmentRequest = (el: OrdersShipmentDeliveryConfirmFileType) => {
        // Construct OrdersExportShipmentExcelType object with required properties
        mutateDownloadShipmentFile(el);
    }

    const btnSearchTransfer = () => {
        // if (pcsDetail?.invoiceNo?.length !== 13) {
        //     handleModal({
        //         isOpen: true,
        //         contents: "올바르지 않은 송장번호입니다.",
        //         type: "alert"
        //     })
        // } else {
        //     window.open(`https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${pcsDetail.invoiceNo}&displayHeader=`, "_blank", "noopener,noreferrer")
        // }
        window.open(`https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=${pcsDetail.invoiceNo}&displayHeader=`, "_blank", "noopener,noreferrer")
    }

    // 내부수정: 발주 상세보기
    return <div className="content_wrap">
        <h5 className="subheading mt-0">{menuTitleText}정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <tbody>
                    <tr>
                        {/* 내부수정: 수주고객 고객사 자리 변경, 컬럼명 변경 */}
                        <th style={{ width: "16.66%" }}>성명</th>
                        <td>{pcsDetail.contactName}</td>
                        <th style={{ width: "16.66%" }}>회사명</th>
                        <td style={{ width: "33.34%" }}>{pcsDetail.enduserName}</td>
                    </tr>
                    <tr>
                        <th style={{ width: "16.66%" }}>납품희망일</th>
                        <td style={{ width: "33.34%" }}>{pcsDetail.newDtRequestShipment}</td>
                        <th style={{ width: "16.66%" }}>배송방법</th>
                        {/* 내부수정: 납품페이지면 shipment 기준 배송방법 */}
                        <td>{isPcsDelivery ? pcsDetail.deliveryPShipmentName : pcsDetail.newPShipmentName}</td>
                    </tr>
                    <tr>
                        <th>수신자</th>
                        {/* 내부수정: 납품페이지면 shipment 기준 수신자 */}
                        <td>{isPcsDelivery ? pcsDetail.deliveryRecipientName : pcsDetail.recipientName}</td>
                        <th>연락처</th>
                        {/* 내부수정: 납품페이지면 shipment 기준 연락처 */}
                        <td>{isPcsDelivery ? pcsDetail.deliveryRecipientMobile : pcsDetail.recipientMobile}</td>
                    </tr>
                    <tr>
                        <th>배송지 (기존 주소 선택)</th>
                        {/* 내부수정: 납품페이지면 shipment 기준 배송지 */}
                        <td colSpan={3}>{isPcsDelivery ? pcsDetail.deliveryAddressName : pcsDetail.addressName}</td>
                    </tr>
                    <tr>
                        <th>주소1</th>
                        {/* 내부수정: 납품페이지면 shipment 기준 주소1 */}
                        <td>{isPcsDelivery ? pcsDetail.deliveryAddress1 : pcsDetail.address1}</td>
                        <th>주소2</th>
                        {/* 내부수정: 납품페이지면 shipment 기준 주소2 */}
                        <td>{isPcsDelivery ? pcsDetail.deliveryAddress2 : pcsDetail.address2}</td>
                    </tr>
                    <tr>
                        <th rowSpan={2}>신규 배송지 (새 주소 등록 요청)</th>
                        <td colSpan={3}>{`${pcsDetail.customPostcode && pcsDetail.customPostcode !== "" ? `(${pcsDetail.customPostcode ?? ""}) ` : ""}${pcsDetail.customAddress1 ?? ""}`}</td>
                    </tr>
                    <tr>
                        <td colSpan={3}>{pcsDetail.customAddress2 ?? ""}</td>
                    </tr>
                    <tr>
                        <th>발주 메모</th>
                        <td colSpan={3}>{pcsDetail.customerMemo}</td>
                    </tr>
                    {/*<tr>
                    <th>{menuTitleText}메모</th>
                    <td colSpan={3}>{pcsDetail.memo}</td>
                </tr>*/}
                    <tr>
                        <th>담당자</th>
                        <td>{pcsDetail.owningUserName}</td>
                        <th>{isPcsDelivery ? "발주 번호" : "납품 번호"}</th>
                        <td>{isPcsDelivery ? pcsDetail.purchaseOrderNo : pcsDetail.shipmentNo}</td>
                        <tr></tr>
                    </tr>
                    {/* 내부수정: 납품 상세보기랑 공유 */}
                    {isPcsDelivery && <>
                        <tr>
                            <th>송장번호</th>
                            <td colSpan={3} style={{ display: "flex", alignItems: "center" }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={pcsDetail.invoiceNo}
                                    disabled
                                />
                                <button className="btn btn-info btn_search ms-5px w-90px" onClick={btnSearchTransfer}>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />
                                    배송조회
                                </button></td>
                        </tr>
                        <tr>
                            <th>납품확인서</th>
                            <td>
                                <a href={void 0} className="link-underline"
                                    onClick={() => pcsDetail?.deliveryConfirmFile &&
                                        downloadShipmentRequest(pcsDetail?.deliveryConfirmFile)}
                                >{pcsDetail?.deliveryConfirmFile?.fileOrgname}</a>
                            </td>
                        </tr>
                    </>
                    }
                </tbody>
            </table>
        </div>

        <h5 className="subheading mt-20px">지급정보</h5>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                {/* NOTE: 결제방법 제거됨 */}
                {/*<tbody>*/}
                {/*<tr>*/}
                {/*    <th style={{width: "16.66%"}}>수금예정일</th>*/}
                {/*    <td style={{width: "33.34%"}}>{pcsDetail.newDtEstimatedCollection}</td>*/}
                {/*    <th style={{width: "16.66%"}}>결제방법</th>*/}
                {/*    <td>{pcsDetail.paymentName}</td>*/}
                {/*</tr>*/}
                {/*<tr>*/}
                {/*    <th>계산서담당자</th>*/}
                {/*    <td>{pcsDetail.taxCharge}</td>*/}
                {/*    <th>연락처</th>*/}
                {/*    <td>{pcsDetail.taxMobile}</td>*/}
                {/*</tr>*/}
                {/*<tr>*/}
                {/*    <th>이메일</th>*/}
                {/*    <td colSpan={3}>{pcsDetail.taxEmail}</td>*/}
                {/*</tr>*/}
                {/*</tbody>*/}
                <tbody>
                    <tr>
                        <th style={{ width: "16.66%" }}>지급예정일</th>
                        <td style={{ width: "33.34%" }}>{pcsDetail.newDtEstimatedCollection ?? '연도-월-일'}</td>
                        <th style={{ width: "16.66%" }}>계산서담당자</th>
                        <td>{pcsDetail.taxCharge}</td>
                    </tr>
                    <tr>
                        <th>연락처</th>
                        <td>{pcsDetail.taxMobile}</td>
                        <th>이메일</th>
                        <td>{pcsDetail.taxEmail}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
}